// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"1f40a087","268":"be0e88d4","787":"6d268263"}[chunkId] + ".chunk.js";
};